
<template>
  <v-app id="mail" class="mail">
    <v-toolbar class="app--toolbar"   color="primary" fixed dark>
      <v-toolbar-title class="ml-0 pl-3" to="/" >
        <span class="hidden-sm-and-down" > Association de la Continuité des Générations</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <div>
        <v-btn icon to="/database/DB/fr" >
          <img src="static/icon/aa.png" width="24px">
        </v-btn>
        <v-btn icon to="/database/DB/Ar" >
          <img src="static/icon/tn.png" width="24px">
        </v-btn>

      </div>
    </v-toolbar>
    <div id="social">
      <v-container grid-list-xl fluid style="padding-top: 5%">
        <v-layout row wrap>
          <v-flex lg6 sm6 xs6>
            <img src="static/FAO.png"  width="60%">
          </v-flex>
          <v-flex lg6 sm6 xs6>
            <img src="static/logo.png" align="right"  width="50%">
          </v-flex>
          <!-- mini statistic start -->
          <v-flex lg3 sm6 xs12>
            <mini-statistic
                    icon="fa fa-facebook"
                    :title="countall"
                    sub-title="Totale"
                    caption="Femme"

                    color="green"
            >
            </mini-statistic>
          </v-flex>
          <v-flex lg3 sm6 xs12>

            <v-menu offset-y style="width: 100%">
              <mini-statistic
                      icon="fa fa-facebook"
                      :title="countsfax"
                      sub-title="Sfax"
                      caption="Femme"
                      style="width: 100%"
                      slot="activator"
                      color="indigo"
              >
              </mini-statistic>
              <v-list>
                <v-list-tile>
                  <v-list-tile-title><a style="color: #9c27b0">S2 : </a>{{s3}} <a style="color: #9c27b0">Femmes</a></v-list-tile-title>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-title><a style="color: #9c27b0">S4 : </a>{{s4}} <a style="color: #9c27b0">Femmes</a></v-list-tile-title>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-title><a style="color: #9c27b0">S5 : </a>{{s5}} <a style="color: #9c27b0">Femmes</a></v-list-tile-title>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-title><a style="color: #9c27b0">S6 : </a>{{s6}} <a style="color: #9c27b0">Femmes</a></v-list-tile-title>
                </v-list-tile>

              </v-list>
            </v-menu>

          </v-flex>
          <v-flex lg3 sm6 xs12>

            <v-menu offset-y style="width: 100%">
              <mini-statistic
                      icon="fa fa-google"
                      :title="countgabes"
                      sub-title="Gabès"
                      caption="femme"
                      style="width: 100%"
                      slot="activator"
                      color="red"
              >
              </mini-statistic>
              <v-list>
                <v-list-tile>
                  <v-list-tile-title><a style="color: #9c27b0">G1 : </a>{{g1}} <a style="color: #9c27b0">Femmes</a></v-list-tile-title>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-title><a style="color: #9c27b0">G2 : </a>{{g2}} <a style="color: #9c27b0">Femmes</a></v-list-tile-title>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-title><a style="color: #9c27b0">G3 : </a>{{g3}} <a style="color: #9c27b0">Femmes</a></v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex lg3 sm6 xs12>
            <mini-statistic
                    icon="fa fa-twitter"
                    :title="countmednin"
                    sub-title="Médenine"
                    caption="femme"
                    color="light-blue"
            >
            </mini-statistic>
          </v-flex>
          <!-- mini statistic  end -->
        </v-layout>
      </v-container>

      <v-container grid-list-xl fluid >

        <v-layout row wrap >
          <v-flex lg12 sm12 xs12>
            <h3 style=" color: #0d47a1"><u>Base de donneés </u></h3>
          </v-flex>
          <v-flex lg12 sm12 xs12 >
          <v-card style="padding-left: 20px;padding-right: 20px">
            <v-layout row wrap style="direction: ltr" >
              <v-flex lg6 sm12 xs12 >

                  <v-toolbar card color="white">
                    <v-text-field
                            flat
                            placeholder="Recherche ..."
                            v-model="name"
                            hide-details
                    ></v-text-field>
                    <v-btn icon @click="search1"> <v-icon>search</v-icon></v-btn>
                    <v-btn icon v-show="x2"@click="annuler"> <v-icon>exit_to_app</v-icon></v-btn>
                  </v-toolbar>
              </v-flex>

              <v-flex lg2 sm6 xs6 style="margin-top: 8px" >
                <v-select
                        style="direction:ltr"
                        label="Gouvernorat"
                        v-model="select_s"
                        :items="selections"
                        v-on:change="changedata()"
                ></v-select>
              </v-flex>
              <v-flex lg2 sm6 xs6  style="margin-top: 8px" >
                <v-select
                        style="direction:ltr"
                        label="Zones de Collectes"
                        v-model="select_zone"
                        :items="selectionz"
                        v-on:change="changezone()"
                ></v-select>
              </v-flex>
              <v-flex lg12 sm12 xs12>
                <v-layout row wrap style="direction:ltr" >
                  <v-flex lg3 sm6 xs6 style="margin-top: 8px" >
                    <v-checkbox
                            v-model="nocards"
                            label="Elle n'a pas d'une carte professionnelle"
                            color="red"
                            value="no"
                            hide-details
                            v-on:change="itemSelectionChanged"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex lg3 sm6 xs6 style="margin-top: 8px" >

                    <v-checkbox
                            v-model="yescards"
                            label="Elle a d'une carte professionnelle"
                            color="primary"
                            value="yes"
                            hide-details
                            v-on:change="itemSelectionChanged"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
          </v-flex>
              <v-flex lg12 sm12 xs12>
                <h3 v-show="x1">Résultat du recheche :{{nbr}}</h3>
                <v-data-table
                        v-show="x1"
                        :headers="basic.headers"
                        :items="recherche"
                        hide-actions
                        :headers-size="20"
                        class="elevation-1"

                >
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td align="center"style="font-size: 15px">{{props.item.identifier }}</td>
                      <td align="center"style="font-size: 15px">


                        <span v-if="(props.item.nomFr!=null)&&(props.item.nomFr!=='')">{{props.item.nomFr }}</span><span v-else>{{props.item.nom }}</span>
                      </td>
                      <td align="center"style="font-size: 15px"> <span v-if="props.item.Gouvernorat==='مدنين'">Médenine</span>
                        <span v-if="props.item.Gouvernorat==='صفاقس'">Sfax</span>
                        <span v-if="props.item.Gouvernorat==='قابس'">Gabès</span>
                        <span v-if="(props.item.Gouvernorat!=='قابس')&&(props.item.Gouvernorat!=='صفاقس')&&(props.item.Gouvernorat!=='مدنين')">{{props.item.Gouvernorat}}</span>
                      </td>                  <td align="center"style="font-size: 15px"><span v-if="(props.item.place!=null)">{{getplace(props.item.place)}}</span><span v-else>-</span></td>
                      <td align="center"style="font-size: 15px">{{props.item.zone }}</td>
                      <td align="center"style="font-size: 15px"><span v-if="(props.item.naissance!=null)">{{props.item.naissance }}</span><span v-else>-</span></td>
                      <td align="center"style="font-size: 15px"> <span v-if="(props.item.cartidentite!=null)">{{props.item.cartidentite }}</span><span v-else>-</span></td>
                      <td align="center"style="font-size: 15px"> <span v-if="(props.item.tel!=null)">{{props.item.tel }}</span><span v-else>-</span></td>
                      <td align="center"style="font-size: 15px"><span v-if="(props.item.carte_pro!=null)">{{props.item.carte_pro }}</span><span v-else>-</span></td>
                      <td align="center"style="font-size: 15px; "><span v-if="(props.item.GDA!=null)&&(props.item.GDA!=='')">{{getGDA(props.item.GDA)}}</span><span v-else>-</span></td>
                      <td align="center"style="font-size: 15px"><span v-if="(props.item.association!=null)&&(props.item.association!=='')">{{getASSo(props.item.association)}}</span><span v-else>-</span></td>
                      <td align="center"style="font-size: 15px"><span v-if="(props.item.syndic!=null)&&(props.item.syndic!=='')">{{getSynd(props.item.syndic) }}</span><span v-else>-</span></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>

          <v-flex lg12 sm12 xs12>
            <h4 v-show="x3"style="margin-bottom: 20px ; color: #0d47a1" ><u>Listes des femmes :</u> {{nbr}}</h4>

            <v-data-table
                    :loading="load"
                    v-show="x3"
                    :headers="basic.headers"
                    :items="items"
                    hide-actions
                    class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td align="center"style="font-size: 15px">{{props.item.identifier }}</td>
                  <td align="center"style="font-size: 15px">


                    <span v-if="(props.item.nomFr!=null)&&(props.item.nomFr!=='')">{{props.item.nomFr }}</span><span v-else>{{props.item.nom }}</span>
                  </td>
                  <td align="center"style="font-size: 15px"> <span v-if="props.item.Gouvernorat==='مدنين'">Médenine</span>
                    <span v-if="props.item.Gouvernorat==='صفاقس'">Sfax</span>
                    <span v-if="props.item.Gouvernorat==='قابس'">Gabès</span>
                    <span v-if="(props.item.Gouvernorat!=='قابس')&&(props.item.Gouvernorat!=='صفاقس')&&(props.item.Gouvernorat!=='مدنين')">{{props.item.Gouvernorat}}</span>
                  </td>
                  <td align="center"style="font-size: 15px">
                      <div style="width: 100px">
                      <span v-if="(props.item.place!=null)">{{getplace(props.item.place)}}</span><span v-else>-</span>
                      </div></td>
                  <td align="center"style="font-size: 15px">{{props.item.zone }}</td>
                  <td align="center"style="font-size: 15px">
                    <div style="width: 100px">
                    <span v-if="(props.item.naissance!=null)">{{props.item.naissance }}</span><span v-else>-</span>

                       </div>

                   </td>
                  <td align="center"style="font-size: 15px"> <span v-if="(props.item.cartidentite!=null)">{{props.item.cartidentite }}</span><span v-else>-</span></td>
                  <td align="center"style="font-size: 15px"> <span v-if="(props.item.tel!=null)">{{props.item.tel }}</span><span v-else>-</span></td>
                  <td align="center"style="font-size: 15px"><span v-if="(props.item.carte_pro!=null)">{{props.item.carte_pro }}</span><span v-else>-</span></td>
                  <td align="center"style="font-size: 15px; ">
                    <div style="width: 200px">
                    <span v-if="(props.item.GDA!=null)&&(props.item.GDA!=='')">{{getGDA(props.item.GDA)}}</span><span v-else>-</span>
                    </div>
                  </td>
                  <td align="center"style="font-size: 15px">
                    <div style="width: 200px">
                  <span v-if="(props.item.association!=null)&&(props.item.association!=='')">{{getASSo(props.item.association)}}</span><span v-else>-</span>
                  </div>
                  </td>
                  <td align="center"style="font-size: 15px"><div style="width: 200px"><span v-if="(props.item.syndic!=null)&&(props.item.syndic!=='')">{{getSynd(props.item.syndic) }}</span><span v-else>-</span></div></td>
                  <td align="center"style="font-size: 15px">{{props.item.CNSS }}</td>
                  <td align="center"style="font-size: 15px">{{props.item.CarteMedG }}</td>
                  <td align="center"style="font-size: 15px">{{props.item.CarteMedFT }}</td>
                  <td align="center"style="font-size: 15px">{{props.item.SCFB}}</td>

                </tr>
              </template>
            </v-data-table>

          </v-flex>

          <v-flex lg12 sm12 xs12>

            <div slot="widget-content" class="text-xs-center" v-show="x3">

              <v-pagination :length="total" v-model="page" circle :total-visible="10"></v-pagination>

            </div>
          </v-flex>
        </v-layout>

      </v-container>
    </div>
  </v-app>
</template>

<script>
  import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';

  import { getPost } from '@/api/post';
  import VWidget from '@/components/VWidget';
  import { MailMenu } from '@/api/mail';
  import Compose from './../components/email/Compose';
  export default {

    timers: {
      log: { time: 500, autostart: true ,  repeat: true,
      }
    },
    components: {
      MiniStatistic,

      Compose,
      VWidget,
    },
    props: {
      source: String
    },
    data () {
      return {
        load: false,

        e2: null,
        e3: null,
        countriess:'الكل',
        type:'Q1',
        s3:'0',
        s5:'0',
        s4:'0',
        s6:'0',
        g2:'0',
        g1:'0',
        g3:'0',
        countall:"+100",
        countsfax:"+100",
        countgabes:"+100",
        countmednin:"+100",
        selections:  ['Toutes les villes','Sfax','Médenine', 'Gabès'],
        selectionz: ['Zones de Collectes','s2','s4','s5','s6',  'G1', 'G2', 'G3', 'M'],
        x1: false,
        x2: false,
        x3: true,
        nbr: 0,
        page: 1,
        s1: false,
        s2: false,
        name: '',
        select_zone: '',
        select_s: '',
        select_s1: '',
        list: null,
        listLoading: true,
        tableData: [],
        recherche: [],
        total: 0,
        items: [],
        nocards:'no',
        yescards  :'yes',
        countries_zone:'',
        search: '',
        basic: {
          headers: [
            {
              text: 'Identifiant',
              align: 'center',
              value: 'identifier',
              width:'800px'
            },
            {
              text: 'Nom & Prénom',
              align: 'center',
              sortable: false,
            },
            {
              text: 'Gouvernorat',
              align: 'center',
              sortable: false,
            },
            {
              text: 'imada',
              align: 'center',
              sortable: false,
            },
            {
              text: 'Zones de Collecte',
              align: 'center',
              sortable: false,
            },
            {
              text: 'Date de  naissance',
              align: 'center',
              sortable: false,
            },
            {
              text: 'CIN',
              align: 'center',
              sortable: false,
            },
            {
              text: 'Téléphone',
              align: 'center',
              sortable: false,
            },
            {
              text: 'Carte Pro',
              align: 'center',
              sortable: false,
            },

            {
              text: 'GDA',
              align: 'center',
              sortable: false,
              width:'700px !important'
            },
            {
              width:'800px',
              text: 'Association',
              align: 'center',
              sortable: false,
            },
            {

              text: 'Syndic',
              align: 'center',
              sortable: false,
            },
            {

              text: 'CNSS',
              align: 'center',
              sortable: false,
            },    {

              text: 'Carte médicale gratuite',
              align: 'center',
              sortable: false,
            },    {

              text: 'Carte de médicale à faible taux',
              align: 'center',
              sortable: false,
            },    {

              text: 'Une subvention continentale pour les familles dans le besoin',
              align: 'center',
              sortable: false,
            },

          ],
        },
      }
    },
    beforeCreate: function () {
      if (this.$session.exists()) {
        this.$router.push('/database/DB/fr')
      }
      else { this.$router.push('/login')}
    },
    created(){
      this.load=true;

      this.start();
      this.fetchData();
      this.fetchcount();
      this.group_count()
      this.load=false;

    },
    watch: {
      page: function(newVal, oldVal) {
        if(this.select_zone===''||this.select_zone==='Zones de Collectes'){
          this.fetchData()
        }
        else{
          this.fetchDatazone()
        }

      }
    },
    methods: {
      log () {
        /*  console.clear()
                  this.fetchData()*/
      },
      start() {
        if(this.select_s===''||this.select_s==='Toutes les villes')
        {
          this.select_s1='tt'
        }
        if(this.select_s==='Sfax')
        {
          this.select_s1='صفاقس'
        }
        if(this.select_s==='Gabès')
        {
          this.select_s1='قابس'
        }
        if(this.select_s==='Médenine')
        {
          this.select_s1='مدنين'
        }
        this.countries_zone='countries';

        if( this.nocards===""&&   this.yescards===""){
          this.nocards='no';
          this.yescards  ='yes';
        }

        this.$http.get('https://acg-generations.com/acg_laravel/public/paginationBDCountries1/'+this.select_s1+'/'+ this.yescards+'/'+this.nocards,
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
          var data = response.bodyText
          var obj = JSON.parse(data);
          this.total=obj.aa;
          this.nbr=obj.count;
        }, response => {
          // error callback
        });
      },
      changedata(){
        this.page=1;
        console.log(this.select_s)
        this.start();
        this.fetchData();
      },
      startZone() {
        if(this.select_zone===''||this.select_zone==='Zones de Collectes')
        {
          this.select_zone='tt'
        }
        this.countries_zone='zone';

        if( this.nocards===""&&   this.yescards===""){
          this.nocards='no';
          this.yescards  ='yes';
        }
        this.$http.get('https://acg-generations.com/acg_laravel/public/paginationBDzone1/'+this.select_zone+'/'+ this.yescards+'/'+this.nocards,
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
          var data = response.bodyText
          var obj = JSON.parse(data);
          this.total=obj.aa;
          this.nbr=obj.count;
        }, response => {
          // error callback
        });
      },
      changezone(){
        this.load=true;
        this.page=1;
        console.log(this.select_s)
        this.startZone();
        this.fetchDatazone();
        this.load=false;
      },
      fetchDatazone() {
        if(this.select_zone===''||this.select_zone==='Zones de Collectes')
        {
          this.select_zone='tt'
        }
        this.cPage = this.page - 1;
        var formData = new FormData();
        formData.append('zone',this.select_zone);
        formData.append('page',this.cPage);
        this.countries_zone='zone';

        if( this.nocards===""&&   this.yescards===""){
          this.nocards='no';
          this.yescards  ='yes';
        }
        formData.append('yescards',this.yescards);
        formData.append('nocards',this.nocards);
        this.$http.post('https://acg-generations.com/acg_laravel/public/GetAllBDzone1',formData,
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
          var data = response.bodyText
          var obj = JSON.parse(data);
          this.items = obj.BD;
        }, response => {
          // error callback
        });
      },
      fetchData() {
        if(this.select_s===''||this.select_s==='Toutes les villes')
        {
          this.select_s1='tt'
        }
        if(this.select_s==='Sfax')
        {
          this.select_s1='صفاقس'
        }
        if(this.select_s==='Gabès')
        {
          this.select_s1='قابس'
        }
        if(this.select_s==='Médenine')
        {
          this.select_s1='مدنين'
        }
        this.cPage = this.page - 1;
        var formData = new FormData();
        formData.append('pays',this.select_s1);
        formData.append('page',this.cPage);
        this.countries_zone='countries';

        if( this.nocards===""&&   this.yescards===""){
          this.nocards='no';
          this.yescards  ='yes';
        }
        formData.append('yescards',this.yescards);
        formData.append('nocards',this.nocards);
        this.$http.post('https://acg-generations.com/acg_laravel/public/GetAllBDCountries1',formData,
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
          var data = response.bodyText
          var obj = JSON.parse(data);
          this.items = obj.BD;
        }, response => {
          // error callback
        });
      },
      itemSelectionChanged: function() {
        if(this.countries_zone==="countries"){
          this.load=true;
          this.page=1;
          this.start();
          this.fetchData();
          this.load=false;
        }
        else{
          this.load=true;
          this.page=1;
          this.startZone();
          this.fetchDatazone();
          this.load=false;
        }
      },
      search1() {
        if(this.name.length>2){
          this.recherche=""
          this.x1=true;
          this.x2=true;
          this.x3=false;
          var formData = new FormData();
          formData.append('nom', this.name);
          this.$http.post('https://acg-generations.com/acg_laravel/public/getsearchBD',formData ,
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
            var data = response.bodyText
            var obj = JSON.parse(data);
            this.recherche = obj.count;
            this.nbr=obj.count.length
          }, response => {
            // error callback
          });
        }

      },
      annuler() {
        this.recherche=""
        this.x1=false;
        this.x2=false;
        this.x3=true;
        this.nbr=0

      },
      getplace(place){
        switch (place) {
          case 'قرقور': return 'Gargour'; break;
          case 'الصخيرة': return 'Skhira'; break;
          case 'عقارب': return 'Agareb'; break;
          case 'الغريبة': return 'Al ghariba'; break;
          case 'زبوسة': return 'Zaboussa'; break;
          case 'عقارب قرقور': return 'Agareb'; break;
          case 'عقارب - قرقور': return 'Agareb'; break;
          case 'الفريشات': return 'Frishat'; break;
          case 'المحرس': return 'Mahres'; break;
          case 'الحشيشينة الجنوبية': return 'Hashishina du Sud'; break;
          case 'الخوالة': return 'Khawala'; break;
          case 'زركين': return 'Zarkin'; break;
          case 'اجيم': return 'Ajim'; break;
          case 'آجيم': return 'Ajim'; break;
          case 'مزران': return 'Mizzran'; break;
          case 'المغراوية': return 'Maghrawya'; break;
          case 'أجيم': return 'Ajim'; break;
          case 'ىجيم': return 'Ajim'; break;
          case 'سيدي مخلوف': return 'Sidi Makhlouf'; break;
          case 'مدينة حومة السوق': return 'Ville de Houmt Souk'; break;
          case 'حومة السوق جربة': return 'Ville de Houmt Souk'; break;
          case 'مارث': return 'Marth'; break;
          case 'ليماية': return 'Limeya'; break;
          case 'العمرات المطوية': return 'Matwia'; break;
        }

      },
      getSynd(synd){
        switch (synd) {
          case 'نقابة الصيد البحري': return 'syndicat de pêche'; break;
          case 'الإتحد الجهوي للفلاحة بصفاقس': return 'union régional d\'agricole et de pêche sfax'; break;
          case 'نقابة جمع المحار': return 'syndicat collection de palourde'; break;
          case 'نقابة النساء جامعات المحار': return 'syndicat des femmes collectrices de palourde'; break;
          case 'إتحاد الفلاحة و الصيد البحري': return 'union d\'agricole et de pêche'; break;
          case 'المحار': return 'syndicat collection de palourde'; break;
          case 'إتحاد الفلاحة و الصيد البحري بصفاقس': return 'union régional d\'agricole et de pêche sfax'; break;
          case 'الإتحاد التونسي للفلاحة و الصيد البحري': return 'union tunisien d\'agricole et de pêche'; break;
          case 'UTAP': return 'UTAP'; break;
          case 'النقابة النسائية لصيد المحار': return 'syndicat des femmes collectrices de palourde'; break;
          case 'جمع المحار': return 'collection de palourde'; break;
          case 'URAP': return 'URAP'; break;
        }

      },
      getGDA(GDA){
        switch (GDA) {
          case 'مجمع التنمية و إستغلال المحار بالهيشة': return 'complexe de développement de palourde à elhicha\n'; break;
          case 'مجمع الهيشة': return 'complexe de développement de palourde à elhicha'; break;
          case 'مجمع تنمية و إستغلال المحار بالهيشة': return 'complexe de développement de palourde à elhicha'; break;
          case 'مجمع تنمية المحار بالهيشة': return 'complexe de développement de palourde à elhicha'; break;
          case 'مجمع التنمية في القطاع الفلاحي بآجيم': return 'complexe de développement dans le secteur agricole de Ajim Djerba'; break;
          case 'مجمع التنمية في القطاع الفلاحي بآجيم بجربة': return 'complexe de développement dans le secteur agricole de Ajim Djerba'; break;
          case 'مجمع التنميو  و الصيد البحري بآجيم جربة': return 'complexe de développement dans le secteur agricole de Ajim Djerba'; break;
          case 'مجمع الصيد البحري بآجيم جربة': return 'complexe de développement dans le secteur agricole de Ajim Djerba'; break;
          case 'مجمع الصيد البحري آجيم جربة': return 'complexe de développement dans le secteur agricole de Ajim Djerba '; break;
          case  'مجمع التنمية للصيد البحري بآجيم جربة' : return 'complexe de développement dans le secteur agricole de Ajim Djerba '; break;
          case 'مجمع الصيحد البحري بآجيم جربة' : return 'complexe de développement dans le secteur agricole de Ajim Djerba '; break;
          case    'مجمع التنمية بآجيم جربة' : return 'complexe de développement dans le secteur agricole de Ajim Djerba '; break;
          case  'مجمع التنمية للصيد البحري بآجيم'   : return 'complexe de développement dans le secteur agricole de Ajim Djerba '; break;
          case  'مجمع الصد البحري آجيم جربة'  : return 'complexe de développement dans le secteur agricole de Ajim Djerba '; break;
          case   'مجمع ااصيد البحري آجيم جربة' : return 'complexe de développement dans le secteur agricole de Ajim Djerba '; break;
          case  'مجمع الصيد البحري اجيم جربة'   : return 'complexe de développement dans le secteur agricole de Ajim Djerba '; break;
          case  'مجمع الصيد البحري باجيم جربة' : return 'complexe de développement dans le secteur agricole de Ajim Djerba '; break;
          case   'مجمع  الصيد البحري بآجيم'  : return 'complexe de développement dans le secteur agricole de Ajim Djerba '; break;
          case 'مجمع التنمية في الصيد البحري بآجيم جربة'  : return 'complexe de développement dans le secteur agricole de Ajim Djerba '; break;
          case 'مجمع الصيد البحري اجيم'  : return 'complexe de développement dans le secteur agricole de Ajim Djerba '; break;
          case 'مجمع الصيد البحري بآجيم'  : return 'complexe de développement dans le secteur agricole de Ajim Djerba '; break;
          case 'جمع التنمية في القطاع الفلاحي  الصيد البحري'  : return 'complexe de développement dans le secteur agricole'; break;
          case 'مجمع التنمية في القطاع الفلاحي و الصيد البحري'  : return 'complexe de développement dans le secteur agricole'; break;
          case 'مجمع الصيد البحري'  : return 'complexe de développement dans le secteur agricole'; break;
        }

      },
      getASSo(synd){
        switch (synd) {
          case 'الجمعية النسائية لصيد المحار': return 'association des femmes de pêche'; break;
          case 'َAFPD': return 'AFPD'; break;
          case 'محار الهيشة': return 'palourde elhicha'; break;
          case 'الجمعية النسائية لصيد المحار و التنمية': return 'association des femmes collectrices de palourde'; break;
          case 'الجمعية النسائية لجمع المحار': return 'association des femmes collectrices de palourde'; break;
          case 'جمعية جمع المحار بصفاقس': return 'association collection de palourde sfax'; break;
          case 'جمعية تواصل الأجيال': return 'ACG'; break;
          case 'جمعية النسائية لصيد المحار': return 'association des femmes collectrices de palourde'; break;
          case 'جمعية تواصل الأجيال بصفاقس': return 'ACG Sfax'; break;
          case 'الجمعية النسائية للصيد البحري': return 'association des femmes de pêche'; break;
          case 'جمعية الفلاحة و الصيد البحري': return 'complexe de développement dans le secteur agricole'; break;
          case 'الجمعية القرآنية': return 'association de coran'; break;
          case 'مجمع التنمية المحار بالهنشية': return 'complexe de développement dans le secteur agricole'; break;
          case 'العكاريت جمعية  الصيد البحري': return 'complexe de développement dans le secteur agricole'; break;
          case 'True': return '-'; break;
          case 'False': return '-'; break;
        }

      },
      pageChange (page, range)
      {
        console.log(page, range);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        console.log(`current page: ${val}`);
        this.fetchData()
      },

      handleClick: (e) => {
        console.log(e);
      },
      changeroute(ch){
        console.log(ch);
        if(ch==='العربية'){
          this.$router.push('/database/Ar')

        }
        else{
          this.$router.push('/database/Fr')
        }

      },
      openThemeSettings () {
        this.$vuetify.goTo(0);
        this.rightDrawer = (!this.rightDrawer);
      },
      fetchcount() {
        this.$http.get('https://acg-generations.com/acg_laravel/public/count_paysBD',
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
          var data = response.bodyText
          var obj = JSON.parse(data);
          this.countall=obj.count.all;
          this.countsfax=obj.count.sfax;
          this.countgabes=obj.count.gabes;
          this.countmednin=obj.count.mednin;
        }, response => {
          // error callback
        });
      },
      group_count() {
        this.$http.get('https://acg-generations.com/acg_laravel/public/group_paysBD',
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
          var data = response.bodyText
          var obj = JSON.parse(data);
          this.s3=obj.count.sfaxS2;
          this.s4=obj.count.sfaxS4;
          this.s6=obj.count.sfaxS6;
          this.s5=obj.count.sfaxS5;
          this.g2=obj.count.gabesG2;
          this.g1=obj.count.gabesG1;
          this.g3=obj.count.gabesG3;
        }, response => {
          // error callback
        });
      },
    }
  }
</script>
<style>

  table.v-table thead th{
    color: black;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/BD.vue